exports.getBegomaDisplayData = () => {
    return {
        originalName: "Begoma",
        name: "Begoma",
        isExpress: false,
        tags: [],
    };
};
